import { useState, useEffect } from 'react';
import { SystemConfigModel } from '../models/SystemConfigModel';
import { obtenerConfiguracionesService } from '../../../../service/systemconfig/SystemConfigService';

export function useObtenerConfiguraciones(reload: number) {
  const [configs, setConfigs] = useState<SystemConfigModel[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    obtenerConfiguracionesService()
      .then((data) => setConfigs(data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [reload]);

  return { configs, loading };
}
